import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGradleComponent } from './simple-icons-gradle.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGradleComponent ],
    exports:      [ SimpleIconsGradleComponent ],
    bootstrap:    []
})
export class SimpleIconsGradleModule {}
